import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const getLeadSources = (params) => ({
  type: actionTypes.GET_LEAD_SOURCES,
  params
});

export const createLeadSource = (payload) => ({
  type: actionTypes.CREATE_LEAD_SOURCE,
  payload
});

export const updateLeadSource = (payload) => ({
  type: actionTypes.UPDATE_LEAD_SOURCE,
  payload
});

export const updateLeadSourceStatus = (Id) => ({
  type: actionTypes.UPDATE_LEAD_SOURCE_STATUS,
  Id
});

export const deleteLeadSource = (Id) => ({
  type: actionTypes.DELETE_LEAD_SOURCE,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});
